import React, { useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import LibraryList from "../../components/libraryList/libraryList";

function Library() {
  useEffect(() => {
    document.title = "Wishallbook >> Ebook Library";
  }, []);

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <LibraryList type="books" />
      </div>
    </div>
  );
}

export default Library;
